/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmailIcon from '@mui/icons-material/Email';
import api from '../../utils/functions/api';
import { getStorage } from '../../utils/functions/localstorage';

const FinalConfirmationPopup = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: '15px',
        width: '400px',
      },
    }}
  >
    <DialogContent>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '24px',
          marginTop: '20px',
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
        />
        บันทึกสำเร็จ !
      </Box>
    </DialogContent>
    <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          width: '25%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid',
          borderRadius: '9px',
          color: '#45A6F5',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#E3F3FF',
          },
          margin: 'auto',
        }}
      >
        <Button onClick={onClose}>Close</Button>
      </Box>
    </DialogActions>
  </Dialog>
);

const EditAccountManagementSuperAdmin = ({ open, onClose, data }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (data) {
      setEmail(data.email || '');
    }
  }, [data]);

  const handleEdit = async () => {
    try {
      const { data: responseData } = await api.put(
        `${process.env.REACT_APP_APIHOST}/eentry/users/${data.id}`,
        {
          // id: data.id,
          role: 'Super Admin',
          email: email,
          createBy: getStorage('username'),
        },
        {
          headers: { Authorization: getStorage('token') },
        },
      );
      if (responseData.status === 'success') {
        setShowConfirmation(true);
      }
    } catch (error) {
      console.log(error.message);
      alert('An error occurred while editing the data.');
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '500px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
              marginTop: '20px',
            }}
          >
            แก้ไขบัญชี
          </Box>
          <IconButton
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <EmailIcon sx={{ marginRight: '30px' }} />
            <TextField
              label="อีเมลล์"
              variant="outlined"
              size="small"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
          <Button
            onClick={onClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleEdit}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </>
  );
};

export default EditAccountManagementSuperAdmin;
